import React, { useState } from 'react';
import { service } from '../../../../_services/conversation.service';
import { history } from '../../../../_helpers/history';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { Button, Modal } from 'react-bootstrap';

function EndAction({ conversationId, handleClose }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [ending, setEnding] = useState(false);

  const handleEnd = () => {
    setEnding(true);
    service.closeConversation(conversationId)
      .then(() => {
        handleClose()
      })
      .catch(() => {
        setShow(false)
        setEnding(false);
        dispatch(alertActions.error('Could not close this conversation at this time. Please try again later.'));
      });
  }

  return <>
    <button onClick={() => setShow(true)}
      type="button"
      className="btn btn-danger w-100">End Conversation</button>

    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>End Conversation</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to end the conversation with the patient?</Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleEnd}
          variant="primary"
          disabled={ending}
          className='w-25'
        >
          {ending ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Yes'}</Button>

        <Button
          variant="secondary"
          disabled={ending}
          onClick={() => setShow(false)}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default EndAction;